module.exports = __webpack_public_path__ + "images/backgrounds/fall/small.68f3da00754622421d9b.jpg";